/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import { UitkCardPlaceholder } from "uitk-react-cards";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import { ItemKeyHelper } from 'src/components/common/helper';

export interface GridPlaceholderProps {
  templateComponentId: string;
  loadingCards: number;
  columns?: {medium: number, extra_large: number, small: number}
}

export const GridPlaceholder = (gridPlaceholderProps: GridPlaceholderProps) => {
  const {templateComponentId, loadingCards = 6, columns = { medium: 2, extra_large: 3, small: 1 }} =  gridPlaceholderProps;
  const keyHelper = new ItemKeyHelper(`${templateComponentId}-placeholder-Grid`);

  return (
    <UitkSpacing margin={{ blockend: "three", blockstart: "four" }}>
      <div className="Deals">
        <UitkSpacing margin={{ inline: "three", blockstart: "three" }}>
          <UitkLayoutGrid columns={columns} space="three">
            {[...Array(loadingCards)].map((val, index) => (
              <div key={keyHelper.next()}>
                {/* <UitkCard border={true}> */}
                    <UitkCardPlaceholder className={`placeholder-card ${templateComponentId}`} />
                {/* </UitkCard> */}
              </div>
            ))}
          </UitkLayoutGrid>
        </UitkSpacing>
      </div>
    </UitkSpacing>
  );
};
